import { BaseApiModel } from 'app/models/api/response';

export interface DuplicateAccount {
    userId: number;
    webuserUrl: string | null;
    displayId: string;
    verifiedAt: string | null;
    confidence: number;
}

export class IdVerification extends BaseApiModel {
    status: 'created' | 'succeeded' | 'failed' | 'expired' = 'created';
    hasFlags = false;
    idVerifiedAt: string | null = null;
    nameScore: number | null = null;
    nameMismatch: boolean | null = null;
    profileAgeYears = 0;
    ageDeltaMonths: number | null = null;
    ageDiscrepancy: boolean | null = null;
    genderMismatch: boolean | null = null;
    reusedDocument: boolean | null = null;
    duplicateAccounts: DuplicateAccount[] = [];
    failureReason: string | null = null;
    completedAt: string | null = null;
    idType: string | null = null;
    detectedIdType: string | null = null;
}
